"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userHasFilePermission = void 0;
const types_1 = require("../typings/types");
const Member_1 = require("./Member");
const userHasFilePermission = (permission) => (member) => (file) => {
    if (member && Member_1.isRioux(member)) {
        return true;
    }
    if (member && Member_1.areMembersTheSame(file.owner)(member)) {
        return true;
    }
    const otherPermissions = file.permissions.filter(perm => perm.type === types_1.FileUserAccessControlType.OTHER);
    const signedInPermissions = file.permissions.filter(perm => perm.type === types_1.FileUserAccessControlType.SIGNEDIN);
    const accountPermissions = file.permissions.filter(perm => perm.type === types_1.FileUserAccessControlType.ACCOUNTMEMBER);
    const teamPermissions = file.permissions.filter(perm => perm.type === types_1.FileUserAccessControlType.TEAM);
    const memberPermissions = file.permissions.filter(perm => perm.type === types_1.FileUserAccessControlType.USER);
    let valid = false;
    otherPermissions.forEach(perm => (valid = valid || (perm.permission & permission) > 0));
    if (member === null || valid) {
        return valid;
    }
    signedInPermissions.forEach(perm => (valid = valid || (perm.permission & permission) > 0));
    if (valid) {
        return true;
    }
    accountPermissions.forEach(perm => (valid = valid || (perm.permission & permission) > 0));
    if (valid) {
        return true;
    }
    if (member) {
        memberPermissions.forEach(perm => (valid =
            valid ||
                ((perm.permission & permission) > 0 &&
                    Member_1.areMembersTheSame(member)(perm.reference))));
        if (valid) {
            return true;
        }
        if (teamPermissions.length === 0) {
            return false;
        }
        member.teamIDs.forEach(i => teamPermissions.forEach(perm => (valid =
            valid ||
                (perm.teamID === i &&
                    (perm.permission & permission) > 0))));
    }
    return valid;
};
exports.userHasFilePermission = userHasFilePermission;
//# sourceMappingURL=File.js.map